import React from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import useTranslation from 'next-translate/useTranslation';
import classNames from 'classnames';

import Axios from '@/utils/axios';
import { handleCheckKeyForMail } from '@/utils/handleCheckKey';

import { Button } from '../index';
import ScreenLoader from '../ScreenLoader/ScreenLoader';
import InformationModal from '../InformationModal/InformationModal';

import styles from './Subscribe.module.scss';

const FormSchema = Yup.object().shape({
  email: Yup.string().required().email(),
});

const Subscribe = ({ buttonText, title, description }) => {
  const { t } = useTranslation('common');

  const [activeModal, setActiveModal] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  const formik = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema: FormSchema,
    onSubmit: async (values) => {
      const formData = {
        email: values?.email,
      };

      try {
        setLoading(true);
        await Axios.post('news-subscriptions/', formData);
        setActiveModal(true);
      } finally {
        setLoading(false);
        formik.resetForm();
      }
    },
  });

  return (
    <>
      <ScreenLoader visible={loading} />
      <div
        className={styles.subscribeWrapper}
        itemScope
        itemType='https://schema.org/SubscribeAction'
      >
        <span className={styles.title}>{title}</span>
        <span className={styles.description}>{description}</span>
        <form className={styles.subscribe} onSubmit={formik.handleSubmit}>
          <div className={styles.mailForm}>
            <input
              onKeyDown={handleCheckKeyForMail}
              id='email'
              onChange={(event) =>
                formik.setFieldValue('email', event.target.value)
              }
              value={formik.values.email}
              className={classNames([
                styles.mailForm__input,
                { [styles.error]: formik.errors.email },
              ])}
              autoComplete='off'
              placeholder={t('common:Subscribe placeholder')}
              aria-label={
                formik.values.email || t('common:Subscribe placeholder')
              }
            />
            <Button
              data-testid={'subscribe-button'}
              className={styles.mailForm__button}
            >
              {buttonText}
            </Button>
          </div>
        </form>
      </div>
      <InformationModal
        active={activeModal}
        onClose={() => setActiveModal(false)}
        description={t('tariffSupport.success.description')}
      />
    </>
  );
};

export default Subscribe;
